import {
  Injector,
  NgModule,
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { MdSidenav } from '@angular/material';
import { RouterModule, Router } from '@angular/router';
import { OSharedModule } from '../../shared';

import { OAppSidenavImageModule } from './o-app-sidenav-image.component';
import { OAppSidenavMenuItemModule } from './o-app-sidenav-menu-item.component';
import { OAppSidenavMenuGroupModule } from './o-app-sidenav-menu-group.component';


import {
  AppMenuService,
  MenuRootItem
} from '../../services';

const SMALL_WIDTH_BREAKPOINT = 840;

export const DEFAULT_INPUTS_O_APP_SIDENAV = [];
export const DEFAULT_OUTPUTS_O_APP_SIDENAV = [];


export class OAppSidenavComponent implements OnInit {

  public static DEFAULT_INPUTS_O_APP_LAYOUT = DEFAULT_INPUTS_O_APP_SIDENAV;
  public static DEFAULT_OUTPUTS_O_APP_LAYOUT = DEFAULT_OUTPUTS_O_APP_SIDENAV;

   sidenav: MdSidenav;

  protected appMenuService: AppMenuService;
  protected _menuRootArray: MenuRootItem[];

  protected imageSrc: string;

  constructor(
    protected injector: Injector,
    private router: Router,
    protected elRef: ElementRef
  ) {
    this.appMenuService = this.injector.get(AppMenuService);
    this.menuRootArray = this.appMenuService.getMenuRoots();
  }

  ngOnInit() {
    this.router.events.subscribe(() => {
      if (this.isScreenSmall()) {
        this.sidenav.close();
      }
    });
  }

  isScreenSmall(): boolean {
    return window.matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`).matches;
  }

  get menuRootArray (): MenuRootItem[] {
    return this._menuRootArray;
  }

  set menuRootArray (val : MenuRootItem[]) {
    this._menuRootArray = val;
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-app-sidenav',
  inputs: DEFAULT_INPUTS_O_APP_SIDENAV,
  outputs: DEFAULT_OUTPUTS_O_APP_SIDENAV,
  template: `
    <md-sidenav-container class="application-sidenav-container" [class.opened]="sidenav.opened">

      <md-sidenav #sidenav class="application-sidenav-sidenav" [opened]="!isScreenSmall()" [mode]="'side'"
        [class.mat-drawer-opened]="sidenav.opened"
        [class.mat-drawer-closed]="!sidenav.opened">
        <!--isScreenSmall() ? 'over' : 'side'-->
        <ng-content select="o-app-sidenav-image, [o-app-sidenav-image], .o-app-sidenav-image, [.o-app-sidenav-image]"></ng-content>
        <o-app-sidenav-image class="o-app-sidenav-image"
          opened-src="./assets/images/sidenav-opened.png"
          closed-src="./assets/images/sidenav-closed.png">
        </o-app-sidenav-image>


        <nav *ngFor="let menuRootItem of menuRootArray">

          <ul *ngIf="appMenuService.getMenuItemType(menuRootItem) !== 'group'">
            <o-app-sidenav-menu-item [menu-item]="menuRootItem" [menu-item-type]="appMenuService.getMenuItemType(menuRootItem)" [sidenav-opened]="sidenav.opened">
            </o-app-sidenav-menu-item>
          </ul>

          <o-app-sidenav-menu-group [menu-group]="menuRootItem" [sidenav-opened]="sidenav.opened" *ngIf="appMenuService.getMenuItemType(menuRootItem) === 'group'">
          </o-app-sidenav-menu-group>
        </nav>
      </md-sidenav>

      <div class="application-sidenav-content">
        <ng-content></ng-content>
      </div>
    </md-sidenav-container>
  `,
  styles: [`
    .o-app-sidenav .example-fill-remaining-space{flex:1 1 auto}.o-app-sidenav .application-sidenav-container{width:100%;height:100%}.o-app-sidenav .application-sidenav-container:not(.opened) .mat-drawer-content{margin-right:48px !important;transform:translate3d(48px, 0px, 0px) !important}.o-app-sidenav .application-sidenav-container .mat-drawer-content{position:absolute;right:0;left:0}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav{box-shadow:3px 55px 6px rgba(0,0,0,0.24);padding-bottom:72px;padding-top:5px;width:240px;bottom:0;overflow:auto;height:100%}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav h3{border:none;font-size:16px;font-weight:700;line-height:24px;text-transform:capitalize;margin:0;padding-left:16px}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav ul{list-style-type:none;margin:0;padding:0}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav li{margin:0;padding:0}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav li>a{box-sizing:border-box;display:block;font-size:14px;font-weight:400;line-height:47px;text-decoration:none;padding:0 16px;position:relative}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav .application-sidenav-menugroup{transition:background-color 500ms}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav .application-sidenav-menugroup.active+.application-sidenav-menugroup-items-container ul{margin-top:0px}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav .application-sidenav-menugroup.active+.application-sidenav-menugroup-items-container o-app-sidenav-menu-item:last-child li{border-color:transparent}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav .application-sidenav-menugroup-items-container{overflow:hidden}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav .application-sidenav-menugroup-items-container ul{transition:margin-top 500ms;margin-top:-100%}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closing{transform:translate3d(-191px, 0, 0)}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closed{visibility:visible !important;transform:translate3d(-191px, 0, 0);text-align:center}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closed .application-sidenav-item.application-sidenav-menuitem a{width:48px;max-width:48px;min-width:48px;line-height:48px;padding:0 8px;height:48px}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closed .application-sidenav-item.application-sidenav-menugroup{padding:8px;padding-left:12px;height:48px;-webkit-box-pack:center !important;-ms-flex-pack:center !important;justify-content:center !important}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closed>nav{width:48px;min-width:48px;margin-left:auto}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closed o-app-sidenav-image .application-sidenav-image-container .application-sidenav-image{margin-left:auto;margin-right:-10px}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opening .application-sidenav-item,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closing .application-sidenav-item,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opened .application-sidenav-item{border-bottom-width:0px;border-bottom-style:solid}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opening .application-sidenav-menugroup,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closing .application-sidenav-menugroup,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opened .application-sidenav-menugroup{padding:16px}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opening .application-sidenav-menugroup .application-sidenav-menugroup-arrow,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closing .application-sidenav-menugroup .application-sidenav-menugroup-arrow,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opened .application-sidenav-menugroup .application-sidenav-menugroup-arrow{position:absolute;right:16px;transition:500ms transform cubic-bezier(0.25, 0.8, 0.25, 1)}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opening .application-sidenav-menugroup.active .application-sidenav-menugroup-arrow,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closing .application-sidenav-menugroup.active .application-sidenav-menugroup-arrow,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opened .application-sidenav-menugroup.active .application-sidenav-menugroup-arrow{transform:rotate(90deg)}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opening .application-sidenav-menugroup.active+.application-sidenav-menugroup-items-container ul li>a,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closing .application-sidenav-menugroup.active+.application-sidenav-menugroup-items-container ul li>a,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opened .application-sidenav-menugroup.active+.application-sidenav-menugroup-items-container ul li>a{padding-left:32px}.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opening .application-sidenav-menuitem md-icon,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-closing .application-sidenav-menuitem md-icon,.o-app-sidenav .application-sidenav-container .mat-drawer.application-sidenav-sidenav.mat-drawer-opened .application-sidenav-menuitem md-icon{margin-right:16px}.o-app-sidenav .application-sidenav-container .application-sidenav-content{min-height:100%;display:flex;flex-direction:column}.o-app-sidenav .application-sidenav-container .application-sidenav-content router-outlet+*{flex-grow:1}
  `],
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.o-app-sidenav]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
{type: Router, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'sidenav': [{ type: ViewChild, args: [MdSidenav, ] },],
};
}


export class OAppSidenavModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    OSharedModule,
    OAppSidenavImageModule,
    OAppSidenavMenuItemModule,
    OAppSidenavMenuGroupModule,
    RouterModule
  ],
  declarations: [
    OAppSidenavComponent
  ],
  exports: [OAppSidenavComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
